module.exports = __webpack_public_path__ + "img/cheeseman.059c7d80.jpg";